module.exports = __webpack_public_path__ + "static/media/pw.98481f76.svg";